import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_129dsr49u5: FaireBrandEntity = {
  token: "b_129dsr49u5",
  type: "brand",
  name: "Taylor Made Organics",
  avatarUrl:
    "https://cdn.faire.com/fastly/fd3b3ce9302ecefe60883dd06c7c6390963035f3ced20b613e96193d2dcaa005.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d4f8324a1038b1859f5d07361e36a061703b9470f462a653b5ffa2ba13081ec9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fd3b3ce9302ecefe60883dd06c7c6390963035f3ced20b613e96193d2dcaa005.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d4f8324a1038b1859f5d07361e36a061703b9470f462a653b5ffa2ba13081ec9.jpeg",
  location: "Port Republic, VA, USA",
  minimumOrderDollars: 250,
  rating: 4.8,
  reviewCount: 65,
  isTopShop: true,
  isInsider: true,
  description:
    "Hi, I'm Christy Teter, a Naturopathic Doctor, and creator of Taylor Made Organics located in the small town of Port Republic, Virginia. Our story began when my oldest daughter had a severe diaper rash. That's when the best-selling product, Herbal Skin Salve was created.\n\nWhen I realized how effective the skin salve was on diaper rash and burns, I knew my mission is to help women transform their skin with non-toxic, therapeutic products while building skin-confidence. \n\nSince launching our business in 1997, the product line has grown beyond therapeutics to handmade skincare, body care, and makeup all made with clean, organic ingredients. \n\nOur mission: Helping women transform their skin with organic, therapeutic products while building skin-confidence. \n\nMade in the USA\nFree of Parabens, Dyes, Fragrances, Sulfates\nCruelty-Free | Gluten-Free | Vegan\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:52.851Z",
    importedBy: "entity-db-cli",
  },
};
